<template>
    <div class="recharge-tips">
        <div class="title">{{ title }}</div>
        <div class="tips-content">
            <template v-if="!checkHtml(content)">
                <p v-for="(item, index) in formatContent" :key="index">
                    {{ item }}
                </p>
            </template>
            <template v-else>
                <div v-html="content"></div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Tips',
    props: {
        title: {
            type: String,
            default: '购买提示',
        },
        content: {
            type: String,
            default: '',
        },
    },
    computed: {
        formatContent() {
            if (this.checkHtml(this.content)) {
                return '';
            }
            const text = this.content.replace(new RegExp(/\r/, 'g'), '');
            return text.split('\n');
        },
    },
    methods: {
        checkHtml(htmlStr) {
            const reg = /<[^]+>/g;
            return reg.test(htmlStr);
        },
    },
};
</script>
<style lang="scss">
.recharge-tips {
    position: relative;
    box-sizing: border-box;
    width: 7.02rem;
    margin: 0.16rem 0.24rem 0 0.24rem;
    padding: 0.24rem;
    background: #ffffff;
    border-radius: 0.16rem;
    z-index: 1;
    .title {
        font-size: 0.28rem;
        font-weight: 600;
        color: #252220;
        line-height: 0.4rem;
    }
    .tips-content {
        margin-top: 0.12rem;
        font-size: 0.28rem;
        line-height: 0.56rem;
        color: #4d4d4d;
        &.html {
            background: #f7f7f7;
            border-radius: 0.08rem;
            padding: 0.3rem;
            box-sizing: border-box;
            font-size: 0.24rem;
            color: #333333;
            .tips-content-detail {
                position: relative;
                width: 100%;
                .detail-prefix {
                    position: absolute;
                    display: inline-block;
                    width: 0.32rem;
                    left: 0;
                }
                .detail-text {
                    display: flex;
                    width: 100%;
                    padding-left: 0.32rem;
                    box-sizing: border-box;
                }
            }
            .tips {
                background: url('../../../images/icon-tips.png') no-repeat;
                background-size: contain;
                width: 1.21rem;
                height: 0.37rem;
            }
            ul {
                margin-top: 0.19rem;
            }
        }
    }
}
</style>
